<template>
    <div class="auth-page">
        <div class="app-content content">
            <div class="content-wrapper">
                <!-- <div class="content-wrapper-before"></div> -->
                <div class="content-header row"></div>
                <div class="content-body">
                    <div class="card">
                        <div class="card-content">
                            <div class="card-body">
                                <section
                                    class="flexbox-container row d-flex align-items-center justify-content-center reset_container"
                                >
                                    <div class="col-6 reset_mobile">
                                        <div class="card">
                                            <div class="card-content">
                                                <div class="card-body">
                                                    <div
                                                        class="row justify-content-center d-flex"
                                                    >
                                                        <div class="col-md-12">
                                                            <div
                                                                class="login-card text-center px_20 py_20"
                                                            >
                                                                <form
                                                                    class="form-horizontal proximaNova-regular"
                                                                    method="post"
                                                                    @submit.prevent="
                                                                        onSubmit
                                                                    "
                                                                    data-vv-scope="resetform"
                                                                >
                                                                    <div
                                                                        class="card-left"
                                                                    >
                                                                        <div
                                                                            class="font-large-1"
                                                                        >
                                                                            <h1>
                                                                                Reset
                                                                                Password
                                                                            </h1>
                                                                            <p>
                                                                                Reset
                                                                                your
                                                                                password
                                                                                !
                                                                            </p>
                                                                        </div>

                                                                        <fieldset
                                                                            class="form-group position-relative has-icon-left d-none"
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                class="form-control round proximaNova-regular"
                                                                                id="user-name"
                                                                                placeholder="Token"
                                                                                name="reset_token"
                                                                                v-model="
                                                                                    post_data.reset_token
                                                                                "
                                                                                v-validate="
                                                                                    'required'
                                                                                "
                                                                            />
                                                                            <small
                                                                                class="form-text text-error text-left"
                                                                                v-show="
                                                                                    errors.has(
                                                                                        'resetform.reset_token'
                                                                                    )
                                                                                "
                                                                            >
                                                                                {{
                                                                                    errors.first(
                                                                                        "resetform.reset_token"
                                                                                    )
                                                                                }}
                                                                            </small>
                                                                        </fieldset>
                                                                        <fieldset
                                                                            class="form-group position-relative has-icon-left"
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                class="form-control round proximaNova-regular"
                                                                                id="user-name"
                                                                                placeholder="Email"
                                                                                name="email"
                                                                                v-model="
                                                                                    post_data.email
                                                                                "
                                                                                v-validate="
                                                                                    'required|email'
                                                                                "
                                                                            />
                                                                            <div
                                                                                class="form-control-position"
                                                                            >
                                                                                <img
                                                                                    class=""
                                                                                    alt=""
                                                                                    src="/admincss/app-assets/images/login/icon-user.png"
                                                                                />
                                                                            </div>
                                                                            <span
                                                                                class="highlight"
                                                                            ></span>
                                                                            <span
                                                                                class="bar"
                                                                            ></span>
                                                                            <small
                                                                                class="form-text text-error text-left"
                                                                                v-show="
                                                                                    errors.has(
                                                                                        'resetform.email'
                                                                                    )
                                                                                "
                                                                            >
                                                                                {{
                                                                                    errors.first(
                                                                                        "resetform.email"
                                                                                    )
                                                                                }}
                                                                            </small>
                                                                        </fieldset>
                                                                        <fieldset
                                                                            class="form-group position-relative has-icon-left"
                                                                        >
                                                                            <input
                                                                                type="password"
                                                                                class="form-control round proximaNova-regular"
                                                                                id="user-password"
                                                                                placeholder="Password"
                                                                                name="password"
                                                                                v-model="
                                                                                    post_data.password
                                                                                "
                                                                                v-validate="
                                                                                    'required|min:6|max:8'
                                                                                "
                                                                                ref="password"
                                                                            />
                                                                            <div
                                                                                class="form-control-position"
                                                                            >
                                                                                <img
                                                                                    class=""
                                                                                    alt=""
                                                                                    src="/admincss/app-assets/images/login/icon-password.png"
                                                                                />
                                                                            </div>
                                                                            <small
                                                                                class="form-text text-error text-left"
                                                                                v-show="
                                                                                    errors.has(
                                                                                        'resetform.password'
                                                                                    )
                                                                                "
                                                                            >
                                                                                {{
                                                                                    errors.first(
                                                                                        "resetform.password"
                                                                                    )
                                                                                }}
                                                                            </small>
                                                                        </fieldset>
                                                                        <fieldset
                                                                            class="form-group position-relative has-icon-left"
                                                                        >
                                                                            <input
                                                                                type="password"
                                                                                class="form-control round proximaNova-regular"
                                                                                id="user-password"
                                                                                placeholder="Confirm Password"
                                                                                name="confirm_password"
                                                                                v-model="
                                                                                    post_data.confirm_password
                                                                                "
                                                                                v-validate="
                                                                                    'required|confirmed:password|min:6|max:8'
                                                                                "
                                                                                data-vv-as="password"
                                                                            />
                                                                            <div
                                                                                class="form-control-position"
                                                                            >
                                                                                <img
                                                                                    class=""
                                                                                    alt=""
                                                                                    src="/admincss/app-assets/images/login/icon-password.png"
                                                                                />
                                                                            </div>
                                                                            <small
                                                                                class="form-text text-error text-left"
                                                                                v-show="
                                                                                    errors.has(
                                                                                        'resetform.confirm_password'
                                                                                    )
                                                                                "
                                                                            >
                                                                                {{
                                                                                    errors.first(
                                                                                        "resetform.confirm_password"
                                                                                    )
                                                                                }}
                                                                            </small>
                                                                        </fieldset>

                                                                        <div
                                                                            class="form-group mb-0"
                                                                        >
                                                                            <a
                                                                                href="#"
                                                                                data-toggle="modal"
                                                                                data-target="#login"
                                                                            >
                                                                                Back
                                                                                to
                                                                                Login
                                                                            </a>
                                                                            <button
                                                                                type="submit"
                                                                                class="btn btn_orange bg_primary_orange text_white w-100 mt_34 btn_h60"
                                                                            >
                                                                                Submit
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="logo-right"
                                                                    >
                                                                        <img
                                                                            class=""
                                                                            alt=""
                                                                            src="/admincss/app-assets/images/login/imprint-city-logo-final.svg"
                                                                        />
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "ResetPassword",
    data() {
        return {
            post_data: {
                reset_token: null,
                email: null,
                password: null,
                confirm_password: null
            }
        };
    },
    mounted() {
        this.post_data.reset_token = this.$route.params.token;
    },
    methods: {
        onSubmit() {
            var _this = this;
            _this.$validator.validateAll("resetform").then((isValid) => {
                if (isValid) {
                    new Promise(() => {
                        ApiService.post("/reset-password/", _this.post_data)
                            .then(({ data }) => {
                                console.log(data);
                                if (data.success) {
                                    _this.$toast.success(
                                        "Password Reset Successfully",
                                        {
                                            position: "top-right"
                                        }
                                    );
                                    _this.$router.push({ path: "/" });
                                } else {
                                    _this.errors.itemslength = 0;
                                    _this.errors.items.push({
                                        id: 1,
                                        vmId: _this.errors.vmId,
                                        field: "email",
                                        msg: data.error,
                                        scope: "resetform"
                                    });
                                }
                                console.log(data, _this.errors.items);
                            })
                            .catch(({ response }) => {
                                _this.errors.itemslength = 0;
                                _this.errors.items.push({
                                    id: 1,
                                    vmId: 3,
                                    field: "email",
                                    msg: response.data.error,
                                    scope: "resetform"
                                });
                                console.log("exception", response.data.error);
                            });
                    });
                } else {
                    console.log("form error", _this.errors);
                }
            });
        }
    }
};
</script>
<style scoped></style>
